
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.571 0c.633 0 1.143.503 1.143 1.125V2.25h4.572V1.125c0-.622.51-1.125 1.143-1.125.632 0 1.142.503 1.142 1.125V2.25h1.715c.946 0 1.714.756 1.714 1.688v1.687H0V3.937C0 3.006.768 2.25 1.714 2.25H3.43V1.125C3.429.503 3.939 0 4.57 0zM0 6.75h16v9.563c0 .931-.768 1.687-1.714 1.687H1.714C.768 18 0 17.244 0 16.312V6.75zm10.893 3.973a.831.831 0 000-1.192.867.867 0 00-1.21 0l-1.68 1.652-1.678-1.652a.863.863 0 00-1.21 0 .834.834 0 000 1.192l1.678 1.652-1.679 1.652a.831.831 0 000 1.192.866.866 0 001.211 0l1.679-1.652 1.678 1.652c.336.33.879.33 1.21 0a.834.834 0 000-1.192l-1.678-1.652 1.679-1.652z","fill":"#20182E"}})])
          )
        }
      }
    